import { defineMessages } from 'react-intl';

export default defineMessages({
  deleteUser: 'Czy na pewno chcesz usunąć użytkownika?',
  deleteOrganizations: 'Czy na pewno chcesz usunąć placówkę?',
  deleteQuestion: 'Czy na pewno chcesz usunąć pytanie?',
  deleteSurvey: 'Czy na pewno chcesz usunąć ankietę?',
  deleteAnswer: 'Czy na pewno chcesz usunąć zestaw odpowiedź?',
});
